import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async (options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.common.createId, {}, options);
    if (error) return { error, status };
    return content || { value: '' };
};
